import React from 'react'

interface BusswerksLogoProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizeClasses = {
  sm: 'text-lg leading-none',
  md: 'text-2xl leading-none',
  lg: 'text-3xl sm:text-4xl leading-none',
} as const

export const BusswerksLogo: React.FC<BusswerksLogoProps> = ({
  size = 'md',
  className = '',
}) => (
  <span
    className={`font-display tracking-wide ${sizeClasses[size]} ${className}`}
    aria-label="Busswerks"
  >
    Busswerks
  </span>
)
